import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../../lib/api.service';
import { StorageService } from '../../lib/storage.service';
import { LogService } from '../../lib/log.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { User } from '../../models/user';
import { UserService } from '../../lib/user.service';
import { Organization } from '../../models/organization';
import { ModalService } from '../../lib/modal.service';
import { Invite } from '../../components/invite/invite';
import { CreateDemoUser } from '../../components/admin/create-demo-user/create-demo-user.component';

import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'page-organization-view.component',
    templateUrl: 'organization-view.component.html',
    styleUrls: ['./organization-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class OrganizationViewPage implements OnInit, OnDestroy {
    id: number;
    user: User;
    organization: Organization = <any>{};
    logoPath: string = '';
    popups: any[];
    isAdmin = false;
    default: any;
    placeholders: any;
    paramsSub: any;
    users: User[];
    professionals: User[];
    jointprofessionals: User[];
    executives: User[];
    executiveprofessionals: User[];
    internalUsers: User[];
    accesscodes: Array<Object>;
    invites: Array<Object> = [];
    isloaded: boolean = false;
    accesscodelink: string = '';
    subdomainlink: string = '';
    isLoading: boolean = false;
    isActivityTabEnabled: boolean = false;
    selectedInviteType: string = 'relationshipmanager'
    userType = [
        {
            key: 'userinvite', name: 'User'
        },
        { key: 'adminprofessional', name: 'Professional' },
        { key: 'adminexecutive', name: 'Executive' },
        { key: 'adminexecutiveprofessional', name: 'Executive Professional' },
        { key: 'relationshipmanager', name: 'Relationship Manager' }
    ];
    constructor(
        private api: ApiService,
        private storage: StorageService,
        private router: Router,
        private modalService: ModalService,
        private log: LogService,
        private userService: UserService,
        private translate: TranslateService,
        private activatedRoute: ActivatedRoute
    ) {
        this.user = this.userService.getUser();
    }

    ngOnInit() {
        this.isLoading = true;
        this.translate.stream('organizationInfo').subscribe((res: any) => {
            this.default = res.default;
            this.placeholders = res.placeholders;
            this.popups = res.popups;
        });

        this.activatedRoute.params.subscribe((params: Params) => {
            this.id = parseInt(params['id'], 10);
            this.storage.set('orgId', this.id, false);
        });

        this.api.get('organizations/' + this.id).subscribe(
            (result: any) => {
                this.log.debug(result);
                this.organization = new Organization(result.data);
                if (this.organization.logo) {
                    this.logoPath =
                        this.organization.id +
                        '/logos/' +
                        this.organization.logo;
                }
                if (this.organization.subdomain) {
                    this.subdomainlink =
                        'https://' +
                        this.organization.subdomain +
                        '.welltrack-boost.com/register';
                } else {
                    this.subdomainlink =
                        'https://app.welltrack-boost.com/register';
                }
                this.api.post(
                    'audit/logorganizationview/' + this.organization.id,
                    {}
                );
                this.id = this.organization.id;
                this.loadMembers();
                this.loadAccessCodes();
                this.loadInvites();
                this.isActivityTabEnabled = true;
            },
            (error: any) => {
                this.log.error('Error getting organizations. ' + error.message);
                this.isLoading = false;
            },
            () => {
                this.isLoading = false;
            }
        );
    }

    loadMembers() {
        this.api.get('admin/usersfromorg', { OrgID: this.id, Type: 1 }).subscribe(
            (result: any) => {
                this.users = User.initializeArray(result.data);
            },
            (error: any) => {
                this.log.error('Error getting users. ' + error.message);
            }
        );

        this.api.get('admin/usersfromorg', { OrgID: this.id, Type: 2 }).subscribe(
            (result: any) => {
                this.professionals = User.initializeArray(result.data);
            },
            (error: any) => {
                this.log.error('Error getting users. ' + error.message);
            }
        );

        this.api.get('admin/usersfromorg', { OrgID: this.id, Type: 3 }).subscribe(
            (result: any) => {
                this.executives = User.initializeArray(result.data);
            },
            (error: any) => {
                this.log.error('Error getting users. ' + error.message);
            }
        );

        this.api.get('admin/usersfromorg', { OrgID: this.id, Type: 4 }).subscribe(
            (result: any) => {
                this.executiveprofessionals = User.initializeArray(result.data);
            },
            (error: any) => {
                this.log.error('Error getting users. ' + error.message);
            }
        );

        this.api.get('admin/usersfromorg', { OrgID: this.id, Type: 5 }).subscribe(
            (result: any) => {
                this.jointprofessionals = User.initializeArray(result.data);
            },
            (error: any) => {
                this.log.error('Error getting users. ' + error.message);
            }
        );

        // Internal users (admins / relationship managers) are tied to an
        // org through organization_internal_user rather than the
        // organization_user / Type column. The backend reads that table
        // when Type=6 is requested.
        this.api.get('admin/usersfromorg', { OrgID: this.id, Type: 6 }).subscribe(
            (result: any) => {
                this.internalUsers = User.initializeArray(result.data);
            },
            (error: any) => {
                this.log.error('Error getting users. ' + error.message);
            }
        );

    }

    loadAccessCodes() {
        this.api.get('admin/accesscodes', { OrgID: this.id }).subscribe(
            (result: any) => {
                this.accesscodes = result.data;
                if (this.accesscodes[0]) {
                    this.accesscodelink =
                        'https://app.welltrack-boost.com/?accesscode=' +
                        this.accesscodes[0]['Code'];
                }
            },
            (error: any) => {
                this.log.error('Error getting access codes. ' + error.message);
            }
        );
    }

    loadInvites() {
        this.onTypeChange(this.selectedInviteType);
    }

    ngOnDestroy() {
        if (this.paramsSub) {
            //this.paramsSub.unsubscribe();
        }
    }

    createAccessCode() {
        this.router.navigate(['/admin/organization', this.id, 'access-code']);
    }

    onDeleteAccessCode(i) {
        this.modalService
            .showConfirmation(
                'Delete',
                'Are you sure you want to remove this access code'
            )
            .afterClosed()
            .subscribe(result => {
                if (result) {
                    let code = this.accesscodes[i];
                    this.api
                        .delete('admin/deleteaccesscode/' + code['ID'])
                        .subscribe(
                            (result: any) => {
                                this.accesscodes.splice(i, 1);
                            },
                            (error: any) => {
                                this.log.error(
                                    'Error getting users. ' + error.message
                                );
                            },
                            () => {}
                        );
                }
            });
    }

    getInvites() {
        this.api.get('admin/invites', { OrgID: this.id }).subscribe(
            (result: any) => {
                this.invites = result.data;
                this.isloaded = true;
            },
            (error: any) => {
                this.log.error('Error getting invites. ' + error.message);
            }
        );
    }

    showInvite(inviteType: string) {
        let inviteInfo;
        let orgId;
        if (this.id) {
            orgId = this.id;
        } else {
            orgId = this.storage.get('orgId');
        }

        if (inviteType == 'executiveprofessional') {
            inviteInfo = {
                type: 'admin',
                endpoint: 'adminexecutiveprofessional',
                orgId: orgId,
            };
        } else if (inviteType == 'executive') {
            inviteInfo = {
                type: 'admin',
                endpoint: 'adminexecutive',
                orgId: orgId,
            };
        } else if (inviteType == 'professional') {
            inviteInfo = {
                type: 'admin',
                endpoint: 'adminprofessional',
                orgId: orgId,
            };
        } else if (inviteType == 'jointprofessional') {
            inviteInfo = {
                type: 'admin',
                endpoint: 'adminjointprofessional',
                orgId: orgId,
            };
        } else if (inviteType == 'user') {
            inviteInfo = {
                type: 'admin',
                endpoint: 'userinvite',
                orgId: orgId,
            };
        } else if (inviteType == 'relationshipmanager') { 
            inviteInfo = {
                type: 'admin',
                endpoint: 'rminvite',
                orgId: orgId,
            };
        }

        const modal = this.modalService.showComponent(Invite, inviteInfo);

        modal.beforeClosed().subscribe((data: any) => {
            this.onTypeChange(this.selectedInviteType);
        });
    }

    editOrganization() {
        this.router.navigate(['/admin/organization', this.id, 'edit']);
    }

    doRemoveInvite(id) {
        this.api.delete('admin/deleteinvite/' + id).subscribe(
            (data: any) => {
                this.modalService.showAlert(
                    'Success',
                    'Invite has been deleted'
                );
                let index = this.invites.findIndex((invite: any) => {
                    return invite.ID == id;
                });
                this.invites.splice(index, 1);
            },
            (error: any) => {
                this.modalService.showAlert(
                    'Error',
                    'Something went wrong. Please try again'
                );
            }
        );
    }

    doResend(id) {
        this.api.post('admin/resendinvite', { ID: id }).subscribe(
            (data: any) => {
                this.modalService.showAlert(
                    'Success',
                    'Invite has been resent'
                );
            },
            (error: any) => {
                this.modalService.showAlert(
                    'Error',
                    'Something went wrong. Please try again'
                );
            }
        );
    }

    createDemoUser() {
        this.modalService.setCloseonClick(false);
        this.modalService.showComponent(CreateDemoUser, this.organization);
    }
    onTypeChange(type: string) {
        this.isloaded = false;
        if (type !== 'relationshipmanager') {
            this.api.get('allinvites/internaluser', { OrgID: this.id, InviteType: type }).subscribe(
                (result: any) => {
                    this.invites = result.data;
                    this.isloaded = true;
                },
                (error: any) => {
                    this.log.error('Error getting invites. ' + error.message);
                }
            );
        } else {
            this.api.get('rminvites/internaluser', { OrgID: this.id }).subscribe(
                (result: any) => {
                    this.invites = result.data;
                    this.isloaded = true;
                },
                (error: any) => {
                    this.log.error('Error getting invites. ' + error.message);
                    this.invites = [];
                }
            );
        }
    }
}
